import UPNG from 'upng-js';
import imageScaler from '../image-scaler/image-scaler';

const { scaleToPowerOfTwo } = imageScaler;

// Image Cache is a storage common to all instances
// Normally we do not allow any persistent data out of the models,
// but putting the whole image data into the model cannot be done as
// we need to have typed arrays. In this particular case, we consider that
// info to be immutable, and therefore cacheable. Because of this reason,
// we store an Id in the model, which could be used later to retrieve the
// image. This id is mangled to be the stencil plus the suffix _data.
// like rugby_data. The reason to mangle is that conceptually the stencil
// name and the stencil data are two different concepts.

const _imageCache = {};

export const venueStencilHelperFactory = ({ aGetAsset }) => {
    const parseStencils = (node, parentStencils) => {
        let stencils = parentStencils;
        const properties = node.properties;

        if (properties) {
            const { stencil, type } = properties;

            if (type === 'venue_stencil') {
                stencils = {
                    ...parentStencils,
                    [stencil]: true,
                };
            }
        }

        const contents = node.contents;

        if (contents) {
            Object.keys(contents).forEach((childName) => {
                const child = contents[childName];

                stencils = {
                    ...stencils,
                    ...parseStencils(child, stencils),
                };
            });
        }
        return stencils;
    };

    const _loadStencilImage = async (stencil) => {
        const assetPath = `venue-stencils/${stencil}.png`;

        const data = await aGetAsset({ assetPath, type: 'binary' });
        const t1 = Date.now();
        const img = UPNG.decode(data);

        const dataRGBA = new Uint8Array(UPNG.toRGBA8(img)[0]);
        const srcImageData = {
            data: dataRGBA,
            height: img.height,
            width: img.width,
        };
        const t2 = Date.now();

        console.log(`Texture decode time: ${t2 - t1}`);
        const scaledImageData = scaleToPowerOfTwo({ imageData: srcImageData });
        const maxU = srcImageData.width / scaledImageData.width;
        const maxV = srcImageData.height / scaledImageData.height;
        const t3 = Date.now();

        const stencilId = `${stencil}_data`;

        _imageCache[stencilId] = {
            id: stencilId,
            originalImageData: srcImageData,
            imageData: scaledImageData,
            minU: 0,
            maxU,
            minV: 0,
            maxV,
        };
        console.log(`Texture scale time: ${t3 - t2}ms`);
        return stencilId;
    };

    const aGrabStencils = async (stencils) => {
        const promises = [];
        const stencilNames = Object.keys(stencils);

        for (let i = 0; i < stencilNames.length; i++) {
            const stencilName = stencilNames[i];

            promises.push(_loadStencilImage(stencilName));
        }
        const loadResults = await Promise.all(promises);
        const result = {};

        for (let i = 0; i < stencilNames.length; i++) {
            const stencilName = stencilNames[i];
            const imageRecord = loadResults[i];

            result[stencilName] = imageRecord;
        }
        return result;
    };

    return {
        parseStencils,
        aGrabStencils,
    };
};

export const getStencilData = (stencil) => _imageCache[stencil];

export default {
    venueStencilHelperFactory,
    getStencilData,
};
